import DOMPurify from 'dompurify';
function sanitizeHTML(dirtyHTML) {
    return DOMPurify.sanitize(dirtyHTML);
}
export { sanitizeHTML, };
//# sourceMappingURL=sanitize-html.js.map